module.exports = __webpack_public_path__ + "static/media/undo.a8faaa94.png";